import axios from "axios";
import { getApiServerProPath } from "../Helper/ReadWriteApiPath";
import { URI } from "../Constants/ApiConstants";
import { versionMock } from "./MockService/VersionServiceMock"
import { FILE_DOES_NOT_EXIST } from "../Constants/ErrorMessage";
import { chooseFile, isFileExist } from "../Helper/FileHelper";

export const getUpdatedVersions = async (centerId) => {
  if (process.env.NODE_ENV === "test") {
    return versionMock;
  }
  const { data } = await axios.get(`${getApiServerProPath()}/${URI.Entity.versions}/${URI.Entity.gsta}/${centerId}`);
  return data;
};

export const getJsonContent = async (filepath, language) => {
  let result = null;
  
  if(!language){
    if (await isFileExist(filepath, "json")) {
      result = await axios.get(`${filepath}.json`);
    }
    else {
      throw new Error(FILE_DOES_NOT_EXIST + `: ${filepath}.json`);
    }
  }
  else {
    let file = await chooseFile(filepath, language, "json");
    if (!file) {
      throw new Error(FILE_DOES_NOT_EXIST + `: ${filepath}_${language}.json`);
    }
    result = await axios.get(file);
  }

  return result.data;
}